import { DownloadJobResult } from "../../Core/Api/JobBroker/job-broker-api-service";
import { jobBrokerService } from "../../Core/Api/services";
import { JobTypes } from "../../Core/Api/Types/job-types";
import useCustomSnackbar from "./useCustomSnackbar";
import { useTranslation } from "react-i18next";

const useJobActions = () => {
  const { t } = useTranslation();
  const enqueueCustomSnackbar = useCustomSnackbar();

  const DownloadBatonQcPdf = async (objectId: number): Promise<DownloadJobResult> => {
    try {
      const response = await jobBrokerService.ListByObjectId(objectId);
      const jobId = response.jobs?.find((x) => x.type === JobTypes.QcVerifyFileBaton)?.id ?? null;

      if (jobId !== null) {
        enqueueCustomSnackbar(t("alert:success.reportIsBeingPrepared"), "success");
        const { data, fileName } = await jobBrokerService.DownloadJobResult(jobId);
        return { data, fileName };
      } else {
        enqueueCustomSnackbar(t("alert:error.noQcVerifyFileBatonJobFoundForAsset", { id: objectId }), "error");
        return { data: "", fileName: "" };
      }
    } catch (e) {
      enqueueCustomSnackbar(t("alert:error.fetchingQcVerifyFileBatonJob"), "error");
      return { data: "", fileName: "" };
    }
  };

  return {
    DownloadBatonQcPdf,
  };
};

export default useJobActions;
